export class MultiPlateUpdate{
  "plateids" : string[];
  "labid":string;
  "step":string;
  "status":string;
  "puid":string;
  "actionRunTime":number;
  "action":string;
  "plateUpdateInfoList" : PlateUpdateInfo[];
  "liquidHandler": string;
  "chemicals": Array<any>;
  "machineUpdateInfoDict" = new Map();
  "processFlow"?: string = "";
  "workFlow"?: string = "";
  "sender"?: string = "";
  "qcNanodrop"?: Boolean = false;
  "lastUpdatedPlateID"?: string;
  "preSpin"?: string = "";
  "spin"?: string = "";
  "shake"?: string = "";
  "seal"?: string = "";
  "plateUpdateListForRecombine"? :PlateUpdateInfo[] = [];
  "completeProcessStep"?: boolean = false;
  "addFirstAction"?: any = null;
  "projectID": string="";
  "projectName"?: string="";
  "beadChipRedo"?: boolean = false;
  "boxID"?: string = "";
  "boxReceptionDate"?: Date;
  "plateUpdateMap"? = {};
}

export class PlateUpdateInfo{
  plateID: string;
  wgaPlateID: string;
  pgxPlateID: string;
  lysisPlateID: string;
  dnaPlateID: string;
  magMixPlateID: string;
  aliquotPlateID: string;
  liquidHandler: string;
  chemicals: Array<any>;
  lastUpdatedPlateID:string;
  addFirstAction: any;
  redo?: string;
  status?: string;
  sampleType?: string;
  stepName?: string;
  redoLabel?: string;
  workflow?: string;
  boxId?: string;
}

export class PrecellPlateInfo{
  plateID: string;
  processFlow: string
}

export class MultiMergePlateQCUpdate {
  plateids: string[] = [];
  labid?: string;
  step?: string;
  status?: string;
  puid?: string;
  actionRunTime?: number;
  action?: string;
  plateUpdateInfoList: {} = {};
}

export class MergeSourcePlatesDTO {
  labId?: string;
  plateIDs: string[] = []
}